// Components - UI
import UserIcon from '@/components/ui/UserIcon/UserIcon.vue';
import SiteCount from '@/components/ui/SiteCount/SiteCount.vue';
import ReviewStars from '@/components/ui/ReviewStars/ReviewStars.vue';
import WashroomsCount from '@/components/ui/WashroomsCount/WashroomsCount.vue';
import SubscriptionLevel from '@/components/ui/SubscriptionLevel/SubscriptionLevel.vue';
import WashroomCountSingle from '@/components/ui/WashroomCountSingle/WashroomCountSingle.vue';
import PercentageCardContents from '@/components/ui/PercentageCardContents/PercentageCardContents.vue';

// Services
import WashroomsService from '@/services/WashroomsService.js';
import MultisitesService from '@/services/MultiSitesService.js';
import ServiceRelationshipsService from '@/services/ServiceRelationshipsService.js';

// Mixins
import StaggerEntranceTransition from '@/components/mixins/StaggerEntranceTransition/StaggerEntranceTransition.vue';

// EventBus
import { EventBus } from '@/EventBus.js';

export default {

  name: 'retailers-multi',

  mixins: [
    StaggerEntranceTransition
  ],

  components: {
    UserIcon,
    SiteCount,
    ReviewStars,
    WashroomsCount,
    SubscriptionLevel,
    WashroomCountSingle
  },

  data: function() {
    return {
      retailers: [],
      searchTerm: null,
      showSearch: false
    }
  },

  created: function() {
    // If we are logged in as a service provider
    if(localStorage.getItem('userGroup') == 'service-providers') {
      ServiceRelationshipsService.getAll({serviceProvider: localStorage.getItem('parentId')})
        .then((res) => {
          let retailerIds = [];
          let filters = [];

          // Get DISTINCT ids of retailers that this SP services
          for(let i in res.data) {
            if(res.data[i].retailer && res.data[i].retailer.multiSite) {
              if(retailerIds.indexOf(res.data[i].retailer.multiSite) == -1) {
                retailerIds.push(res.data[i].retailer.multiSite);

                filters.push({id: res.data[i].retailer.multiSite});
              }
            }
          }

          if(filters.length > 0) {
            MultisitesService.getAll(filters, 'or', null, 'name ASC')
              .then((res) => {
                this.retailers = res.data;

                for (let i in this.retailers) {
                  WashroomsService.getByMultisiteId(this.retailers[i].id)
                    .then((res) => {
                      this.$set(this.retailers[i], 'washrooms', res.data);
                    })
                    .catch((err) => {
                      EventBus.dispatchErrorEvent('Whoops! Something went wrong, not all data may have been loaded correctly, please try again.');
                    });
                }
              })
              .catch((err) => {
                EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
              });
          }
        })
        .catch((err) => {
          EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
        });
    }
    else {
      MultisitesService.getAll(null, null, null, 'name ASC')
      .then((res) => {
        this.retailers = res.data;

        for (let i in this.retailers) {
          WashroomsService.getByMultisiteId(this.retailers[i].id)
            .then((res) => {
              this.$set(this.retailers[i], 'washrooms', res.data);
            })
            .catch((err) => {
              EventBus.dispatchErrorEvent('Whoops! Something went wrong, not all data may have been loaded correctly, please try again.');
            });
        }
      });
    }
  },

  mounted: function() {

  },

  beforeDestroy: function() {

  },

  methods: {
    openSearch: function() {
      this.showSearch = true;

      // Wait for element visible before focus
      setTimeout(() => {
        this.$refs.searchInput.focus();
      }, 200);
    },

    closeSearch: function() {
      this.searchTerm = null;
      this.showSearch = false;
    }
  },

  computed: {
    search: function() {
      if(this.searchTerm && this.searchTerm.trim().length > 0) {
        return this.retailers.filter((r) => {
          if (r.name.toLowerCase().trim().indexOf(this.searchTerm.toLowerCase().trim()) > -1  || r.contactEmail.toLowerCase().trim().indexOf(this.searchTerm.toLowerCase().trim()) > -1 || r.contactTelephone.toLowerCase().trim().indexOf(this.searchTerm.toLowerCase().trim()) > -1) {
            return true;
          }

          return false;
        });
      }
      else {
        return this.retailers;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/RetailersMulti/RetailersMulti.js